<template>
<div class="page_">
    <div>
        <a-form layout="inline">
            <a-form-item label="投保日期">
                <a-range-picker :placeholder="['请选择日期', '请选择日期']" style="width: 200px;"></a-range-picker>
            </a-form-item>
            <a-form-item label="投保人">
                <a-input></a-input>
            </a-form-item>
            <a-form-item label="被保人">
                <a-input></a-input>
            </a-form-item>
            <a-form-item>
                <a-button type="primary">查询</a-button>
                <a-button disabled style="margin-left: 8px;" type="default">重置</a-button>
            </a-form-item>
        </a-form>
    </div>
    <a-table 
        style="margin-top: 17px;" 
        :columns="columns" 
        :dataSource="tableData"
        :pagination="pagination"
        @change="handlePageChange"
    >
    </a-table>
</div>
</template>
<style lang="scss" scoped>

</style>
<script>
import navbar from '../components/navbar'
const columns = [{
    title: '保单号',
    key: 'title',
    dataIndex: 'title'
}, {
    title: '产品名称',
    key: 'productName',
    dataIndex: 'productName'
}, {
    title: '保费',
    key: 'policyNo',
    dataIndex: 'policyNo'
}, {
    title: '投保人',
    key: 'insuredPeople',
    dataIndex: 'title'
}, {
    title: '起保日期',
    key: 'startDate',
    dataIndex: 'title'
}, {
    title: '终保日期',
    key: 'endDate',
    dataIndex: 'title'
}, {
    title: '操作',
    key: 'do',
    dataIndex: 'title'
},]

export default {
    data () {
        document.title = '待续保保单'
        return {
            columns,
            tableData: [],
            pagination: {
                total: 1000,
                pageSize: 20,
                pageNum: 1
            }
        }
    },
    components: {
        navbar
    },
    methods: {
        handlePageChange (e) {
            console.log('handlePageChange -> ', e)
        }
    }
}
</script>